
import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useUserProfile } from "@/hooks/useUserProfile";
import { supabase } from "@/integrations/supabase/client";

export const ProtectedRoute = () => {
  const { user, isLoading } = useAuth();
  const { profile, isLoading: isProfileLoading } = useUserProfile();
  const location = useLocation();
  const [forceReady, setForceReady] = useState(false);

  useEffect(() => {
    const isInactiveCompanyUser =
      profile?.nivel !== 0 &&
      profile?.empresa_id !== null &&
      profile?.empresas?.ativo === false;

    if (!isInactiveCompanyUser) {
      return;
    }

    void supabase.auth.signOut();
  }, [profile]);

  // Timeout de segurança para ProtectedRoute
  useEffect(() => {
    console.log("🛡️ ProtectedRoute: Estado atual - isLoading:", isLoading, "user:", user?.email || "null");
    
    const timeout = setTimeout(() => {
      if ((isLoading || isProfileLoading) && !forceReady) {
        console.log("⏰ ProtectedRoute: Timeout - forçando ready");
        setForceReady(true);
      }
    }, 3000);

    return () => clearTimeout(timeout);
  }, [isLoading, isProfileLoading, forceReady, user]);

  // Se ainda está carregando e não foi forçado, mostra loading
  if ((isLoading || isProfileLoading) && !forceReady) {
    console.log("⏳ ProtectedRoute: Ainda carregando...");
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-lg">Carregando...</div>
      </div>
    );
  }

  // Se não tem usuário, redireciona para login
  if (!user) {
    console.log("🚫 ProtectedRoute: Sem usuário - redirecionando para login");
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // CONTROLE DE ACESSO CRÍTICO: Verificar se é admin sem empresa
  if (profile) {
    const isAdmin = profile.nivel === 0;
    const hasEmpresa = profile.empresa_id !== null;
    
    console.log("🔒 ProtectedRoute: Verificação de acesso - isAdmin:", isAdmin, "hasEmpresa:", hasEmpresa);
    
    // Se é admin sem empresa vinculada, redirecionar para admin
    if (isAdmin && !hasEmpresa) {
      console.log("🔴 ProtectedRoute: Admin sem empresa - redirecionando para /admin");
      return <Navigate to="/admin" replace />;
    }
    
    // Se não é admin mas não tem empresa, bloquear acesso
    if (!isAdmin && !hasEmpresa) {
      console.log("🔴 ProtectedRoute: Usuário sem empresa vinculada - acesso negado");
      return (
        <div className="flex items-center justify-center h-screen">
          <div className="text-center">
            <h2 className="text-xl font-semibold text-red-600 mb-2">Acesso Negado</h2>
            <p className="text-gray-600">Você precisa estar vinculado a uma empresa para acessar esta plataforma.</p>
          </div>
        </div>
      );
    }

    if (!isAdmin && profile.empresas?.ativo === false) {
      console.log("🔴 ProtectedRoute: Empresa inativa - redirecionando para login");
      return <Navigate to="/login" replace />;
    }
  }

  console.log("✅ ProtectedRoute: Usuário autenticado - renderizando conteúdo protegido");
  return <Outlet />;
};
